import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Layout } from '@abyss/web/ui/Layout';
import { Popover } from '@abyss/web/ui/Popover';
import { Tooltip } from '@abyss/web/ui/Tooltip';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsOverflow } from '../../../../../../../../../hooks/useIsOverflow';
import { getStatusText } from '../../../../../ShareDrawer/utils';
import {
  StyledAvoidWrappingDiv,
  popoverStyle,
} from '../../../../utility/compareDrawer.styled';
import {
  ATTRIBUTE_STATUS_TEXT,
  NULL_ATTRIBUTE_STATE,
} from '../../../../utility/compareDrawerConstants';

type Props = {
  virtualCareOffered?: string[];
  mobile: boolean;
};

export const VirtualCareOfferedAttribute = ({
  virtualCareOffered,
  mobile,
}: Props) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const isOverflow = useIsOverflow(containerRef);

  const virtualCareOfferredText = getStatusText(
    virtualCareOffered && virtualCareOffered.length > 0,
    ATTRIBUTE_STATUS_TEXT.VIRTUAL_CARE_OFFERED.TRUE,
    ATTRIBUTE_STATUS_TEXT.VIRTUAL_CARE_OFFERED.FALSE,
    NULL_ATTRIBUTE_STATE.VIRTUAL_CARE_OFFERED
  );

  const isAttributeEmpty =
    virtualCareOfferredText === NULL_ATTRIBUTE_STATE.VIRTUAL_CARE_OFFERED;

  const getVirtualCareOffered = (icon) => (
    <StyledAvoidWrappingDiv
      cssProps={{ isOverflow, isAttributeEmpty }}
      ref={containerRef}
    >
      <Layout.Group space={4}>
        <IconMaterial
          color="$primary1"
          data-auto-testid="icon"
          data-testid="icon"
          icon={icon}
          size={20}
        />
        {t(virtualCareOfferredText)}
      </Layout.Group>
    </StyledAvoidWrappingDiv>
  );

  const VirtualCareOffered = () => {
    if (!virtualCareOffered) {
      return getVirtualCareOffered('do_not_disturb');
    }
    if (virtualCareOffered?.length > 0) {
      return getVirtualCareOffered('videocam');
    }
    return getVirtualCareOffered('close');
  };

  if (mobile) {
    return (
      <React.Fragment>
        {isOverflow ? (
          <Popover
            content={virtualCareOfferredText}
            css={popoverStyle}
            showClose={false}
            tabIndex="-1"
            width={150}
          >
            {VirtualCareOffered()}
          </Popover>
        ) : (
          VirtualCareOffered()
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {isOverflow ? (
        <Tooltip
          content={virtualCareOfferredText}
          position="top"
          positionOffset={8}
        >
          {VirtualCareOffered()}
        </Tooltip>
      ) : (
        VirtualCareOffered()
      )}
    </React.Fragment>
  );
};
